import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import whiteBuildingBG from 'src/img/white-building-bg.jpg';
import appfolioBuildingBG from 'src/img/appfolio-building-bg.png';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), helpers), {}, {
  backgroundContainer: {
    padding: '32px 40px',
    position: 'relative',
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      opacity: '0.2',
      backgroundImage: "url(".concat(whiteBuildingBG, ")"),
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover'
    }
  },
  appfolioBackgroundContainer: {
    padding: '32px 40px',
    position: 'relative',
    borderRadius: '2px',
    backgroundImage: "url(".concat(appfolioBuildingBG, ")"),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    '& .MuiTypography-root': {
      color: palette.common.white,
      '& + .MuiTypography-root': {
        marginTop: '10px'
      }
    }
  },
  pageFooter: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  pageCongratulationText: {
    marginLeft: '40px'
  },
  address: {
    marginTop: '12px',
    color: palette.primary.main
  },
  summary: {
    padding: '8px 12px',
    borderRadius: '2px',
    backgroundColor: palette.shades[200],
    display: 'inline-block'
  },
  summaryContainer: {
    '& + &': {
      marginTop: '10px'
    }
  },
  launchDateWrapper: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      marginLeft: '10px'
    }
  },
  checkbox: {
    '& .MuiSvgIcon-root path': {
      fill: palette.success.main
    },
    '& .MuiTypography-root': {
      fontSize: '16px'
    }
  },
  utilityIcon: {
    display: 'inline-block',
    '& + &': {
      marginLeft: '10px'
    }
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: '10'
  },
  congratulationText: {
    marginLeft: '40px'
  },
  paperContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  residentsCounter: {
    padding: '6px 12px',
    backgroundColor: palette.shades[200],
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiTypography-root': {
      marginLeft: '6px'
    }
  },
  utilities: {
    [breakpointsFunc.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  utilitiesList: {
    [breakpointsFunc.breakpoints.down('md')]: {
      marginTop: '20px'
    }
  },
  statusIcon: {
    marginLeft: '20px',
    display: 'inline-block'
  }
}));
export default useStyles;